import React from 'react'
import { inject, observer } from 'mobx-react'
import Name from '../common/Name'
import MoveGeometryButton from 'components/common/tooltips/MoveGeometryButton'
import CopyGeometryButton from 'components/common/tooltips/CopyGeometryButton'

import SharedMessage from '../common/SharedMessage'
import { withTranslation } from 'react-i18next'

import { HugeiconsIcon } from '@hugeicons/react'
import { CenterFocusIcon } from '@hugeicons/core-free-icons'

const SharedGeopolygon = ({ geopolygon, group, uiStore, t }) => (
  <div className='owned-geopolygon'>
    <Name
      label={t('GEOPOLYGON.GEOPOLYGON')}
      name={geopolygon.name}
    />
    <SharedMessage group={group} />
    <section className='owned-geopolygon__list'>
      <button onClick={e => {
        e.currentTarget.blur()
        uiStore.setBoundsToItem(geopolygon)
      }}
      >
        <HugeiconsIcon icon={CenterFocusIcon} size={18} className='popup-menu__icon' />
        <span>{t('GLOBAL.FIT_REGION')}</span>
      </button>
      <CopyGeometryButton
        lgIcon
        group={group}
        onSubmit={() => uiStore.copyGeopolygon(geopolygon, group)}
      />
      <MoveGeometryButton
        lgIcon
        group={group}
        onSubmit={() => uiStore.moveGeopolygon(geopolygon, group)}
      />
    </section>
  </div>
)

export default withTranslation()(inject('uiStore')(observer(SharedGeopolygon)))
